import React from 'react'

function PostContent(props) {
    if (props.content) {
        return (
            <div className="content">{props.content}</div>
        )
    } else {
        return (<span></span>)
    }
}

export default PostContent